import millify from "millify";
import { Separator } from "./ui/separator";
import type { IPost } from "../types/models/post.models.types";
import { DateTime } from "luxon";

export default function PostMetric({ post }: { post: IPost }) {
  if(post.youtube){
     return (
    <div className="border border-border rounded-md">
      <div className="flex justify-between items-center p-5 pb-2">
        <div className="flex flex-col">
          <p className="text-secondary text-xs">Views</p>
          {post.youtube?.metrics?.views
            ? millify(post.youtube?.metrics.views)
            : "-"}
        </div>
        <div className="flex flex-col">
          <p className="text-secondary text-xs">Likes</p>
          {post.youtube.metrics?.likes
            ? millify(post.youtube.metrics?.likes)
            : "-"}
        </div>{" "}
        <div className="flex flex-col">
          <p className="text-secondary text-xs">Shares</p>
          {post.youtube.metrics?.shares
            ? millify(post.youtube.metrics?.shares)
            : "-"}
        </div>
        <div className="flex flex-col">
          <p className="text-secondary text-xs">Comments</p>
          {post.youtube.metrics?.comments
            ? millify(post.youtube.metrics?.comments)
            : "-"}
        </div>
      </div>
      <Separator />
      <div className="flex gap-1 bg-tertiarybuttonbg p-5 pt-2 pb-2 text-xs">
        <p className="text-secondary">Last updated at:</p>
        {post.metricsUpdatedAt
          ? (() => {
              const dt = DateTime.fromISO(post.metricsUpdatedAt.toString());
              return `${dt.toFormat("h:mm a")} - ${dt.toLocaleString(DateTime.DATE_SHORT)}`;
            })()
          : "-"}
      </div>
    </div>
  );
  }
  return (
    <div className="border border-border rounded-md">
      <div className="flex justify-between items-center p-5 pb-2">
        <div className="flex flex-col">
          <p className="text-secondary text-xs">Views</p>
          {post.metricsInstagram?.views
            ? millify(post.metricsInstagram?.views)
            : "-"}
        </div>
        <div className="flex flex-col">
          <p className="text-secondary text-xs">Likes</p>
          {post.metricsInstagram?.likes
            ? millify(post.metricsInstagram?.likes)
            : "-"}
        </div>{" "}
        <div className="flex flex-col">
          <p className="text-secondary text-xs">Shares</p>
          {post.metricsInstagram?.shares
            ? millify(post.metricsInstagram?.shares)
            : "-"}
        </div>
        <div className="flex flex-col">
          <p className="text-secondary text-xs">Comments</p>
          {post.metricsInstagram?.comments
            ? millify(post.metricsInstagram?.comments)
            : "-"}
        </div>
      </div>
      <Separator />
      <div className="flex gap-1 bg-tertiarybuttonbg p-5 pt-2 pb-2 text-xs">
        <p className="text-secondary">Last updated at:</p>
        {post.metricsUpdatedAt
          ? (() => {
              const dt = DateTime.fromISO(post.metricsUpdatedAt.toString());
              return `${dt.toFormat("h:mm a")} - ${dt.toLocaleString(DateTime.DATE_SHORT)}`;
            })()
          : "-"}
      </div>
    </div>
  );
}
